<template>
  <div class="text-xs-center">
    <v-dialog v-model="dialog" fullscreen persistent>
      <v-card height="100%">
        <v-card-title
          class="headline indigo darken-4 white--text fixed-header"
          primary-title
        >
          {{ $vuetify.t('$vuetify.calls.contractNotes').toUpperCase() }}
        </v-card-title>

        <v-card-text>
          {{ notes }}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-text
          class="font-italic text-xs-center title font-weight-regular"
        >
          {{ $vuetify.t('$vuetify.calls.confirmContractNotes') }}
        </v-card-text>

        <div class="footer text-xs-center mb-3">
          <v-divider></v-divider>
          <v-card-text>
            <v-btn @click="back()">
              {{ $vuetify.t('$vuetify.calls.back') }}
            </v-btn>
            <v-btn color="success" @click="confirmContractNotes()">
              {{ $vuetify.t('$vuetify.calls.proceedToTheNextSection') }}
            </v-btn>
            <abort-visit v-on:aborted="visitAborted()" />
          </v-card-text>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import AbortVisit from '@/components/AbortVisit.vue'

export default {
  props: ['show', 'notes'],
  components: {
    AbortVisit
  },
  data() {
    return {
      dialog: false
    }
  },
  methods: {
    confirmContractNotes() {
      this.dialog = false
      this.$emit('confirmed')
    },

    visitAborted() {
      this.dialog = false
      this.$emit('aborted')
    },

    back() {
      this.dialog = false
      this.$emit('back')
    }
  },
  watch: {
    show: function(newVal, oldVal) {
      this.dialog = newVal
    }
  }
}
</script>

<style scoped>
.footer {
  position: -webkit-sticky;
  position: sticky;
  background-color: #ffffff;
  bottom: 0;
  width: 100%;
  height: 100px;
}

.fixed-header {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 300;
}
</style>
